import defaults from './defaults';

const providerType = 'shoppable';

export const shoppableElementDefaults = (provider, permalink) => ({
  legalDisclosure: {
    value: {
      type: 'text',
      settings: {
        name: 'Legal Disclosure',
        noOptionsMenu: true,
        fixedParent: true,
        editable: false,
        noOffCanvasPosition: true,
        styles: {
          ...defaults.text.styles,
          left: 50,
          top: 410,
          width: 450,
          height: 100,
          textFlowOption: 2,
          fontSize: 25,
          textAlign: 'center',
        },
        data: {
          type: 'termsText',
          provider,
          providerType,
          required: true,
          noRemap: true,
          dataKeyMap: {
            text: 'termsText',
          },
        },
      },
      parentId: provider,
      isGroup: false,
    },
  },
  productQrcode: {
    value: {
      type: 'qrcode',
      settings: {
        name: 'QR Code',
        noOptionsMenu: false,
        fixedParent: true,
        editable: true,
        permalink,
        styles: {
          ...defaults.qrcode.styles,
          left: 250,
          top: 130,
          width: 250,
          height: 250,
        },
        data: {
          type: 'affiliateLink',
          provider,
          providerType,
          required: true,
          noRemap: true,
          dataKeyMap: {
            permalink: 'affiliateLink',
          },
        },
      },
      parentId: provider,
      isGroup: false,
    },
  },
  productImage: {
    value: {
      type: 'image',
      settings: {
        name: 'Product Image',
        border: true,
        borderWidth: 2,
        mask: true,
        maskShape: 'oval',
        maskPosition: 'center-center',
        styles: {
          ...defaults.image.styles,
          left: 20,
          top: 130,
          width: 200,
          height: 200,
        },
        data: {
          provider,
          providerType,
          dataKeyMap: {
            imageUrl: 'productImage',
          },
        },
      },
      parentId: provider,
      isGroup: false,
    },
  },
  productPrice: {
    value: {
      type: 'text',
      settings: {
        name: 'Product Price',
        styles: {
          ...defaults.text.styles,
          left: 45,
          top: 339,
          width: 150,
          height: 50,
          textFlowOption: 2,
          textAlign: 'center',
        },
        data: {
          provider,
          providerType,
          dataKeyMap: {
            text: 'productPrice',
          },
        },
      },
      parentId: provider,
      isGroup: false,
    },
  },
  productName: {
    value: {
      type: 'text',
      settings: {
        name: 'Product Name',
        styles: {
          ...defaults.text.styles,
          left: 0,
          top: 0,
          width: 550,
          height: 100,
          textFlowOption: 2,
          textAlign: 'center',
        },
        data: {
          provider,
          providerType,
          dataKeyMap: {
            text: 'productName',
          },
        },
      },
      parentId: provider,
      isGroup: false,
    },
  },
});

export const requiredShoppableElements = ['legalDisclosure', 'productQrcode'];

// values should map to the keys in shoppableElementDefaults
export const shoppableModalOptions = [
  {
    value: 'legalDisclosure',
    title: 'Legal Disclosure',
    icon: 'fas fa-file-alt',
    checked: true, // checked by default because it is required
    disabled: true, // disabled because it is required
  },
  {
    value: 'productQrcode',
    title: 'Product QR Code',
    icon: 'fas fa-qrcode',
    checked: true, // checked by default because it is required
    disabled: true, // disabled because it is required
  },
  {
    value: 'productName',
    title: 'Product Name',
    icon: 'fas fa-signature',
    checked: false,
    disabled: false,
  },
  {
    value: 'productImage',
    title: 'Product Image',
    description: '**This depends on availability from the Shoppable Source.',
    icon: 'fas fa-tshirt',
    checked: false,
    disabled: false,
  },
  {
    value: 'productPrice',
    title: 'Product Price',
    icon: 'fas fa-dollar-sign',
    checked: false,
    disabled: false,
  },
]
